<template>
    <div v-if="stage" class="px-4">
        <v-row>
            <v-col>
                <v-text-field
                    v-model="stage.agent"
                    label="Agente"
                    outlined
                    hide-details="auto"
                    :error="showErrors && !stage.agent"
                    :background-color="showErrors && !stage.agent ? '#DC0B0B1A' : 'white'"
                    @change="computeStage">
                </v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-text-field
                    v-model="stage.conversation"
                    label="Conversación"
                    outlined
                    hide-details="auto"
                    :error="showErrors && !stage.conversation"
                    :background-color="showErrors && !stage.conversation ? '#DC0B0B1A' : 'white'"
                    @change="computeStage">
                </v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-text-field
                    v-model="stage.save_as_key"
                    label="Clave de guardado"
                    outlined
                    hide-details="auto"
                    :error="showErrors && !stage.save_as_key"
                    :background-color="showErrors && !stage.save_as_key ? '#DC0B0B1A' : 'white'"
                    @change="computeStage">
                </v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-text-field
                    v-model="stage.force_tool"
                    label="Forzar tool"
                    outlined
                    hide-details="auto"
                    @change="computeStage">
                </v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-text-field
                    v-model="stage.max_iterations"
                    label="Iteraciones máximas"
                    outlined
                    @input="turnIntoNumber"
                    type="number"
                    hide-details="auto"
                    @change="computeStage">
                </v-text-field>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { CompleteConversation } from '@/modules/document/domain/WorkflowTemplate';
import { DOCS_FIELD_MAP_SHOW } from "@/modules/document/domain/Document";
import RecursivePayloadOfAdressesOnSchemaEditor from '@/modules/document/infra/RecursivePayloadOfAdressesOnSchemaEditor.vue';
// import RouteInBagSelectorComponent from '@/modules/document/infra/RouteInBagSelectorComponent';
// import { get_tree_from_schema } from '@/modules/entities/domain/GetTreeFromSchema';
export default {
    name:'CompleteConversationDetailComponent',
    components: {
        // RouteInBagSelectorComponent
        RecursivePayloadOfAdressesOnSchemaEditor
    },
    props:{
        stage: {
            type: CompleteConversation,
            default: false,
        },
        showErrors: {
            type: Boolean,
            default: false
        },
        available_types: {
            type: Array,
            default: () => []
        },
        my_bag:{
            type: Object,
            required: false,
            default: () => {}
        }
    },
    data(){
        return {
            cssLink: null,
            selected_schema: null
        }
    },
    mounted(){
        console.log(this.stage);
        // this.cssLink = document.createElement('link');
        // this.cssLink.rel = 'stylesheet';
        // this.cssLink.href = 'https://unpkg.com/json-schema-editor-vue/lib/json-schema-editor-vue.css';
        // document.head.appendChild(this.cssLink);
    },
    methods:{
        formatField(field) {
            return DOCS_FIELD_MAP_SHOW[field] || field;
        },
        
        computeStage(){
            this.$emit('compute-stage');
        },
        reset_payload(){
            console.log('reset');
        },
        turnIntoNumber(value) {
        this.stage.max_iterations = value !== '' ? Number(value) : null;
      },
        
    },
    computed:{
        current_type(){
            if (!this.stage.entity_type_id){
                return {'name':'', 'schema':{}};
            }
            let current_type = this.available_types.find(e => e.uuid === this.stage.entity_type_id);
            return current_type;
        },
        // get_context_from_output_type(){
        //     if (this.stage.entity_type_id){
        //         let e_type = this.available_types.find(e => e.uuid === this.stage.entity_type_id);
        //         return get_tree_from_schema(e_type.schema);
        //     }
        //     else{
        //         return {};
        //     }
        // }
    },
    beforeDestroy() {
        // Remove the stylesheet when the component is destroyed
        // if (this.cssLink && document.head.contains(this.cssLink)) {
        // document.head.removeChild(this.cssLink);
        // }
    }
}
</script>

<style scoped >
/*@import url('https://unpkg.com/json-schema-editor-vue@2.3.0/lib/json-schema-editor-vue.css');*/
.preaty__card {
    border-radius: 5px;
}
.small_scrollbar >>> textarea {
    scrollbar-width: thin;
}
.error--text {
    color: rgba(220, 11, 11, 0.898) !important;
}
</style>